import { useCurrentOrganization } from '#/contexts/AuthProvider';
import { API } from '#lib/network/API';

import { useGet } from '..';
import { OrganizationIntegrationsSettingsKeys } from '../api/organizations/OrganizationIntegrationsSettings.keys';
import { useSession } from '../session/useSession';

interface Response {
  isEnabled: boolean;
}

export const useFiskaly = (): Response => {
  const { isAdmin, isBuildingManager, isAgent } = useSession();
  const organizationId = useCurrentOrganization();

  const { data: settings } = useGet(
    OrganizationIntegrationsSettingsKeys.byOrganizationId(organizationId),
    API.organizationIntegrationsSettings.findIntegrationsSettings,
    {
      enabled: isAdmin || isBuildingManager || isAgent
    }
  );

  if (!settings) {
    return {
      isEnabled: false
    };
  }

  return {
    isEnabled: settings.isFiskalyEnabled()
  };
};
